/**
 * Created by Daniela on 26/09/2016.
 */
export const materiaisRouter: string = 'materiais';

export const materialRouter: string = 'lista';
export const materialApi: string = 'Materiais';
export const materialStorageName: string = 'material';
export const materialTitle: any = {plural: 'Materiais', single: 'Material'};

export const materialEspecificacaoRouter: string = 'especificacoes';
export const materialEspecificacaoApi: string = 'materiais-especificadores';
export const materialEspecificacaoStorageName: string = 'materialespecificacao';
export const materialEspecificacaoTitle: any = {plural: 'Especificações', single: 'Especificação'};

export const materialCodigoBarraRouter: string = 'codigo-barra';
export const materialCodigoBarraApi: string = 'materiais-codigos-barra';
export const materialCodigoBarraStorageName: string = 'materialcodigobarra';
export const materialCodigoBarraTitle: any = {plural: 'Códigos de barra', single: 'Código de barra'};

export const tiposMateriais: any[] = [
    { Key: 1, Value: 'Consumo' },
    { Key: 2, Value: 'Permanente' }
];

export const materialGrupoCodigoMask: number = 3;
export const materialCodigoMask: number = 6;

export const materiaisQuery: any = {
    "where":{
        "ativo":true,
        "descricao":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"descricao",
    "include":["medida"]
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/shared/data.service.ts
 **/